import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import ArrButton from '../../../../components/common/arr-button/ArrButton';
import './PreviewCodingForms.scss';
import {useState} from 'react';
import {ArrDrawer} from '../../../../components/common/arr-drawer/ArrDrawer';
import {ToastType} from '../../../../shared/constants';
import {ReactComponent as SuccessIcon} from '../../../../../src/assets/images/success-icon.svg';
import {ReactComponent as InfoIcon} from '../../../../../src/assets/images/info-icon.svg';
import ArrBanner from '../../../common/arr-banner/ArrBanner';
import {CodingFormItem} from '../../../../shared/types';
import DynamicFormFields from './DynamicFormFields';

interface IAssignUsers {
  open: boolean;
  handleDrawer: (open: boolean) => void;
  items: CodingFormItem[];
  formName: string;
}

const PreviewCodingForms: React.FC<IAssignUsers> = ({
  open,
  handleDrawer,
  items,
  formName,
}) => {
  const [validationSuccessType, setValidationSuccessType] =
    useState<boolean>(false);
  const [showBanner, setShowBanner] = useState<boolean>(false);

  const handleCancelOk = () => {
    handleDrawer(false);
  };

  const setMessageType = (message: ToastType) => {
    setShowBanner(true);
    if (message === ToastType.Success) {
      setValidationSuccessType(true);
    } else {
      setValidationSuccessType(false);
    }
  };

  return (
    <ArrDrawer
      showButton={false}
      isOpen={open}
      size="small"
      side="right"
      onClose={handleCancelOk}
      showHeader={false}
    >
      <Box className="preview-form-container">
        <Box className="preview-form-action">
          <Box className="preview-form-label">
            <Typography
              className="typo-text headline3_size preview-form-title"
              data-testid={`preview-coding-forms-title`}
            >
              {t('codingForms.previewCodingForm.title')}
            </Typography>
          </Box>
          <ArrButton
            variant="secondary"
            size="medium"
            onClick={handleCancelOk}
            dataTestId="preview-coding-forms-cancel-button"
            className="cancel-button"
          >
            {t('common.cancel')}
          </ArrButton>
          <ArrButton
            variant="primary"
            size="medium"
            onClick={handleCancelOk}
            dataTestId="save-button"
            className="save-button"
          >
            {t('common.ok')}
          </ArrButton>
        </Box>

        <Box className="preview-form-fields-container">
          <Box className="preview-fields-title">
            <Typography
              className="typo-text subhead5_size default-coding-text"
              data-testid={`preview-coding-forms-form-name`}
            >
              {formName}
            </Typography>
          </Box>
          {
            <Box className="toast-container">
              {showBanner && (
                <ArrBanner
                  type="contextual"
                  variant={
                    validationSuccessType ? ToastType.Success : ToastType.Error
                  }
                  bannerContent={
                    validationSuccessType
                      ? t('codingForms.previewCodingForm.validationSuccess')
                      : t('codingForms.previewCodingForm.validationFailure')
                  }
                  startIcon={
                    validationSuccessType ? <SuccessIcon /> : <InfoIcon />
                  }
                  dataTestId="preview-codeing-banner"
                />
              )}
            </Box>
          }
          <Box className="form-content">
            <DynamicFormFields fields={items} setMessageType={setMessageType} />
          </Box>
        </Box>
      </Box>
    </ArrDrawer>
  );
};

export default PreviewCodingForms;
